import React, { memo } from 'react';

import type { Filter, VehicleListFilterQuery } from 'Types/filter';
import { isDeepEqual } from 'Utilities/helpers/isDeepEqual';
import useFeatureToggle, { FEATURES } from 'Utilities/hooks/useFeatureToggle';
import useVehicleListWrapper from 'Utilities/hooks/vehicleList/useVehicleListWrapper/useVehicleListWrapper';

import VehicleList from './VehicleList';

export interface VehicleListWrapperProps {
	filters: Filter;
	query: VehicleListFilterQuery;
}

const VehicleListWrapper: React.FC<VehicleListWrapperProps> = ({ filters, query }) => {
	const { isError, isLoading, onFetchNextPage, onRefresh, pagination, vehicleCount, vehicles } = useVehicleListWrapper({
		filters,
		query,
	});
	const forceVehicleListErrorScreen = useFeatureToggle(FEATURES.forceVehicleListErrorScreen);

	return (
		<VehicleList
			filters={filters}
			isError={forceVehicleListErrorScreen || isError}
			isLoading={isLoading}
			onLoadMore={onFetchNextPage}
			onRefresh={onRefresh}
			pagination={pagination}
			vehicleCount={vehicleCount}
			vehicles={vehicles}
		/>
	);
};

// Deep props comparison is required for compare prevProps and currentProps
export default memo(VehicleListWrapper, isDeepEqual);
